module.exports = __webpack_public_path__ + "static/media/call.05517fb3.svg";